import PageHero from "../components/PageHero";
import PromotionsStrip from "../components/sections/PromotionsStrip";
import FinalCTA from "../components/sections/FinalCTA";

export default function Promotions() {
  return (
    <>
      <PageHero
        eyebrow="Promotions"
        headline={"Latest cleaning\npromotions."}
        intro="Live seasonal packages from Emilio's Solutions. Ask on WhatsApp for the current best fit for your property."
        image="/generated/service_end_tenancy.png"
        imageAlt="Empty Singapore condo prepared for handover"
        compact
      />
      <PromotionsStrip limit={9} />
      <FinalCTA />
    </>
  );
}
